import { CheckIcon, CopyIcon } from '@radix-ui/react-icons';

import { IconButton } from '~/components/ui/IconButton';
import Markdown from '../markdown';
import { useCopyToClipboard } from '~/hooks/use-copy-to-clipboard';

export default function CompletionResponse({ response, prompt }: { response?: any; prompt?: string }) {
  const { isCopied, copyToClipboard } = useCopyToClipboard({ timeout: 2000 });

  return (
    <div className="group flex flex-1 justify-between gap-2">
      <div className="flex-1">
        {!response || response.length === 0 ? (
          <div className="mt-1 flex items-start justify-start">
            <div className="flex h-6 space-x-1">
              <span className="typing-dots animate-loader"></span>
              <span className="typing-dots animate-loader animation-delay-200"></span>
              <span className="typing-dots animate-loader animation-delay-400"></span>
            </div>
          </div>
        ) : (
          <>
            <h3 className="text-xs font-medium text-zinc-500">Prompt:</h3>
            <Markdown content={(prompt ?? '')?.replace(/\n/giu, '\n\n')} />
            <h3 className="mt-4 text-xs font-medium text-zinc-500">Response:</h3>
            <Markdown content={response.content.replace(/\n/giu, '\n\n')} />
          </>
        )}
        {response?.metadata?.averageTokenTime ? (
          <div className="mt-1 flex items-center justify-start md:justify-end">
            <span className="text-xs text-zinc-400">
              {response.metadata.firstTokenTime?.toFixed(0) || '-- '}ms initial latency{' | '}
              {response.metadata.averageTokenTime.toFixed(2)} tokens/s
            </span>
          </div>
        ) : null}
      </div>
      <IconButton
        onClick={() => copyToClipboard(response.content as string)}
        variant="ghost"
        className="m-1 h-8 w-8 shrink-0 opacity-0 group-hover:opacity-100 max-sm:hidden"
      >
        {isCopied ? <CheckIcon className="h-4 w-4" /> : <CopyIcon className="h-4 w-4" />}
      </IconButton>
    </div>
  );
}
